import { NavLink } from "react-router-dom";

import { useUserInfor } from "../../../Context/User/";
import { ACESSOS } from "../../../Routes/Acessos";
import SubNavDropDown from "../SubNavDropDown/SubNavDropDown";
import { SubNavRelatoriosHelpDesk } from "./subnavs/RelatoriosHelpDesk";
import { SubNavGestaoRespostasHelpdesk } from "./subnavs/GestaoRespostasHelpdesk";
import GestaoCadastroHelpdesk from "./subnavs/GestaoCadastroHelpdesk/GestaoCadastroHelpdesk";

export default function HelpDeskTab() {
    const { UserInfor } = useUserInfor();

    return (
        <div className="tab-pane py-5 p-lg-0 show active" id="HelpDeskTab">
            <div
                id="kt_header_menu"
                className="header-menu header-menu-mobile header-menu-layout-default header-menu-root-arrow"
            >
                <ul className="menu-nav">
                    {UserInfor.TELAS
                        ? UserInfor.TELAS.map((tela) => {
                              if (
                                  tela.ID_TELA ===
                                  ACESSOS.HELPDESK.TELAS.DASHBOARD.ID_TELA
                              ) {
                                  return (
                                      <li
                                          key={tela.ID_TELA}
                                          className="menu-item"
                                      >
                                          <NavLink
                                              to={
                                                  ACESSOS.HELPDESK.TELAS
                                                      .DASHBOARD.DS_PATH
                                              }
                                              exact
                                              activeClassName="active"
                                              className="menu-link"
                                          >
                                              <span className="menu-text">
                                                  Dashboard
                                              </span>
                                          </NavLink>
                                      </li>
                                  );
                              } else return <div key={tela.ID_TELA}></div>;
                          })
                        : null}
                    {UserInfor.TELAS
                        ? UserInfor.TELAS.map((tela) => {
                              if (
                                  tela.ID_TELA ===
                                  ACESSOS.HELPDESK.TELAS.GESTAO_CLIENTES.ID_TELA
                              ) {
                                  return (
                                      <li
                                          key={tela.ID_TELA}
                                          className="menu-item"
                                      >
                                          <NavLink
                                              to={
                                                  ACESSOS.HELPDESK.TELAS
                                                      .GESTAO_CLIENTES.DS_PATH
                                              }
                                              exact
                                              activeClassName="active"
                                              className="menu-link"
                                          >
                                              <span className="menu-text">
                                                  Gestão de Clientes
                                              </span>
                                          </NavLink>
                                      </li>
                                  );
                              } else return <div key={tela.ID_TELA}></div>;
                          })
                        : null}

                    <SubNavDropDown
                        title={"Gestão de Cadastros"}
                        telas={[
                            ACESSOS.HELPDESK.TELAS.GESTAO_RESPOSTAS.ID_TELA,
                            ACESSOS.HELPDESK.TELAS.PESQUISA_SATISFACAO.ID_TELA,
                        ]}
                    >
                        <GestaoCadastroHelpdesk />
                    </SubNavDropDown>

                    {UserInfor.TELAS
                        ? UserInfor.TELAS.map((tela) => {
                              if (
                                  tela.ID_TELA ===
                                  ACESSOS.HELPDESK.TELAS.GESTAO_ATENDIMENTOS
                                      .ID_TELA
                              ) {
                                  return (
                                      <li
                                          key={tela.ID_TELA}
                                          className="menu-item"
                                      >
                                          <NavLink
                                              to={
                                                  ACESSOS.HELPDESK.TELAS
                                                      .GESTAO_ATENDIMENTOS
                                                      .DS_PATH
                                              }
                                              exact
                                              activeClassName="active"
                                              className="menu-link"
                                          >
                                              <span className="menu-text">
                                                  Gestão de Atendimentos
                                              </span>
                                          </NavLink>
                                      </li>
                                  );
                              } else return <div key={tela.ID_TELA}></div>;
                          })
                        : null}

                    {UserInfor.TELAS
                        ? UserInfor.TELAS.map((tela) => {
                              if (
                                  tela.ID_TELA ===
                                  ACESSOS.HELPDESK.TELAS.ATENDIMENTO.ID_TELA
                              ) {
                                  return (
                                      <li
                                          key={tela.ID_TELA}
                                          className="menu-item"
                                      >
                                          <NavLink
                                              to={
                                                  ACESSOS.HELPDESK.TELAS
                                                      .ATENDIMENTO.DS_PATH
                                              }
                                              exact
                                              activeClassName="active"
                                              className="menu-link"
                                          >
                                              <span className="menu-text">
                                                  Atendimento
                                              </span>
                                          </NavLink>
                                      </li>
                                  );
                              } else return <div key={tela.ID_TELA}></div>;
                          })
                        : null}
                    <SubNavDropDown
                        title={"Gestão de Pesquisas"}
                        telas={[
                            ACESSOS.HELPDESK.TELAS.GESTAO_RESPOSTAS.ID_TELA,
                            ACESSOS.HELPDESK.TELAS.PESQUISA_SATISFACAO.ID_TELA,
                        ]}
                    >
                        <SubNavGestaoRespostasHelpdesk />
                    </SubNavDropDown>

                    <SubNavDropDown
                        title={"Relatórios"}
                        telas={[ACESSOS.HELPDESK.TELAS.WHATSAPP_BI.ID_TELA]}
                    >
                        <SubNavRelatoriosHelpDesk />
                    </SubNavDropDown>
                </ul>
            </div>
        </div>
    );
}
